import styles from './Readout.module.css';

export interface ReadoutProps {
  label: string;
  value: string;
  /** Numbers use Share Tech Mono; words (a key) use Archivo */
  kind?: 'number' | 'word';
  /** Tapping opens a stepper or keypad sheet */
  onClick?: () => void;
  /** Accessible name when the tap does something specific, e.g. "Tap BPM" */
  actionLabel?: string;
  disabled?: boolean;
  className?: string;
}

/** BPM, swing, key, and values in settings sheets (DESIGN_SYSTEM §3). */
export function Readout({ label, value, kind = 'number', onClick, actionLabel, disabled, className }: ReadoutProps) {
  const classes = [styles.readout, className].filter(Boolean).join(' ');
  // The space keeps the visible text ("BPM 94") inside the accessible name ("BPM 94, change"): WCAG 2.5.3, Label in Name
  const content = (
    <>
      <span className={styles.label}>{label}</span>{' '}
      <span className={[styles.value, kind === 'number' ? styles.num : styles.word].join(' ')}>{value}</span>
    </>
  );
  if (onClick || disabled) {
    return (
      <button
        type="button"
        className={classes}
        onClick={onClick}
        disabled={disabled}
        aria-label={`${label} ${value}${actionLabel ? `, ${actionLabel}` : ''}`}
      >
        {content}
      </button>
    );
  }
  return <div className={classes} role="group" aria-label={`${label} ${value}`}>{content}</div>;
}
